import React from 'react';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { CommonStyledComponentProps } from '__utils/type';
import { useMediaQuery } from 'react-responsive';

const LoaderContainerDiv = styled.div`
    display: none;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    z-index: 100000;
    background: rgba(255, 255, 255, 1);
`;

const LoaderInnerContainerDiv = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
`;

const LoaderDiv = styled.div<CommonStyledComponentProps>`
    width: 66px;
    height: 66px;
    margin-left: 30%;
    -webkit-animation: contanim 2s linear infinite;
    animation: contanim 2s linear infinite;

    svg {
        display: block;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        position: absolute;
        -webkit-transform: rotate(-90deg);
        transform: rotate(-90deg);
    }


    svg:nth-child(1) circle {
        stroke: ${COLOR.GREEN};
        stroke-dasharray: 1, 300;
        stroke-dashoffset: 0;
        -webkit-animation: strokeanim 3s calc(.2s * (1)) ease infinite;
        animation: strokeanim 3s calc(.2s * (1)) ease infinite;
        -webkit-transform-origin: center center;
        transform-origin: center center;
    }

    svg:nth-child(2) circle {
        stroke: #00E38C;
        stroke-dasharray: 1, 300;
        stroke-dashoffset: 0;
        -webkit-animation: strokeanim 3s calc(.2s * (2)) ease infinite;
        animation: strokeanim 3s calc(.2s * (2)) ease infinite;
        -webkit-transform-origin: center center;
        transform-origin: center center;
    }

    svg:nth-child(3) circle {
        stroke: #00E38C;
        stroke-dasharray: 1, 300;
        stroke-dashoffset: 0;
        -webkit-animation: strokeanim 3s calc(.2s * (3)) ease infinite;
        animation: strokeanim 3s calc(.2s * (3)) ease infinite;
        -webkit-transform-origin: center center;
        transform-origin: center center;
    }

    svg:nth-child(4) circle {
        stroke: ${COLOR.GREEN};
        stroke-dasharray: 1, 300;
        stroke-dashoffset: 0;
        -webkit-animation: strokeanim 3s calc(.2s * (4)) ease infinite;
        animation: strokeanim 3s calc(.2s * (4)) ease infinite;
        -webkit-transform-origin: center center;
        transform-origin: center center;
    }
`;

const Loader: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (<LoaderContainerDiv id="loaderDiv">
        <LoaderInnerContainerDiv>
            <LoaderDiv isMobile={isMobile}>
                <svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle fill="none" strokeWidth="8" strokeLinecap="round" cx="33" cy="33" r="28"></circle>
                </svg>
            </LoaderDiv><br/>
           <span style={{color: COLOR.GREY, fontWeight: "normal"}}>Please wait while we are fetching details</span> 
        </LoaderInnerContainerDiv>
    </LoaderContainerDiv>);
}

export default Loader;